/**
 * An enum representing whether a collection utility action should enforce uniqueness
 */
export enum Unique {
  /** Enforce unqiueness */
  True,

  /** Do not enforce uniqueness */
  False
}
